const ENDPOINTS = {

	GET_ESTABLECIMIENTOS: () =>
		'/api/v1/establecimientos/',

	GET_ESTABLECIMIENTOS_BY_PARAMS: (nombre, activo, cadena) => {
		let url = '/api/v1/establecimientos/' +
			'?estado=' + activo +
			'&nombre:ct=' + nombre;

		if (cadena != "" && cadena != null) {
			url += '&cadena=' + cadena
		}
		return url;
	},

	GET_ESTABLECIMIENTO_BY_ID: (id) =>
		'/api/v1/establecimientos/' + id,

	CREAR_ESTABLECIMIENTO: () =>
		'/api/v1/establecimientos/',

	ACTUALIZAR_ESTABLECIMIENTO: (id) =>
		'/api/v1/establecimientos/' + id,

	DELETE_ESTABLECIMIENTO: () =>
		'/api/v1/establecimientos/'
};

export default ENDPOINTS;